import * as React from "react";

export const MoreVerticalIcon: React.SFC = ({}) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
  >
    <g id="Bounding_Boxes">
      <path fill="none" d="M0,0h24v24H0V0z" />
    </g>
    <g id="Outline_1_">
      <path
        fill="#9b9b9b"
        d="M12,8c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S10.9,8,12,8z M12,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,10,12,10z
		 M12,16c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,16,12,16z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/documentList/MoreVerticalIcon.tsx